import $http from "../file-request.js";

export function getFileAttachmentList(tanantId, module, formId) {
  return $http({
    url: 'file/attachments/' + tanantId + "/" + module + "/" + formId,
    method: 'get',
  });
}


export function getFileAttachmentById(id) {
  return $http({
    url: 'file/attachment/queryById/' + id,
    method: 'get',
  });
}

export function deleteFileById(id) {
  return $http({
    url: 'file/attachment/delete/' + id,
    method: 'post',
    data: {}
  });
}



// WEBPACK FOOTER //
// ./src/common/upload/fileupload-restapi.js